import React from "react";
import { Box, Grid } from "@mui/material";
import PropTypes from "prop-types";
import {
  CheckBox,
  Devices,
  Receipt,
  SignalWifiStatusbar4Bar,
  Store,
  Stream,
  Visibility,
} from "@mui/icons-material";
import TableauDash from "../../../components/commonComponents/TableauDashboard/TableauDash";
import store from "../../../Store/store";
import { checkUserDetailsFromCookie, checkWorkSpaceFromCookies } from "../../../api_calls/userManagement";
import TotalMonitoringFilter from "./filters/TotalMonitoringFilter";
import StoreMonitoringFilter from "./filters/StoreMonitoringFilter";
import StatusMonitoringFilter from "./filters/StatusMonitoringFilter";
import { storeListOptionsForFilter, findStoreIds, independentStoreListOptions, findEmbeddableId } from "../../../api_calls/utils";
import RecieptMonitoringFilter from "./filters/RecieptMonitoringFilter";
import { findMinSelectableDate } from "../../../api_calls/campaigns";
import Dashboard from "../../../components/commonComponents/Embeddable/Dashboard";

// to load tab content
function CustomTabPanel(props) {
  const { children, dasboardname, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={false}
      id={`simple-tabpanel-${dasboardname}`}
      aria-labelledby={`simple-tab-${dasboardname}`}
      {...other}
    >
      <Box sx={{ p: 0 }}>{children}</Box>
    </div>
  );
}

// specify mandatory props that custom tab panel will accept
CustomTabPanel.propTypes = {
  children: PropTypes.node,
  dasboardname: PropTypes.number.isRequired,
};

function dashboardMarkup(embedId, dashboardVariables) {
  const checkUserDetails = checkUserDetailsFromCookie();
  let userDetailObj = {};
  if (checkUserDetails.success === true) {
    userDetailObj = checkUserDetails.user_detail;
  }

  return (
    <Dashboard
      embedDashboardId={embedId}
      variables={dashboardVariables}
      filterConfig={{
        "number_root": userDetailObj.root_company_id.toString(),
      }} />
  );
}

const statusDashboardVariables = () => {
  let dashboardVars = {};
  const userStateData = store.getState().userSelections;
  if (typeof userStateData.embedded_store_monitoring_status !== "undefined") {
    // stores
    if (typeof userStateData.embedded_store_monitoring_status.store_ids !== "undefined" && userStateData.embedded_store_monitoring_status.store_ids.length !== 0) {
      dashboardVars = {
        ...dashboardVars,
        Stores: userStateData.embedded_store_monitoring_status.store_ids,
      }
    }

    // status
    if (typeof userStateData.embedded_store_monitoring_status.status !== "undefined" && userStateData.embedded_store_monitoring_status.status.length !== 0) {
      dashboardVars = {
        ...dashboardVars,
        Status: userStateData.embedded_store_monitoring_status.status,
      }
    }
  }

  return dashboardVars;
}

const totalMonitoringDashboardVariables = () => {
  let dashboardVars = {};
  const userStateData = store.getState().userSelections;
  if (typeof userStateData.embedded_total_monitoring_stores !== "undefined") {
    // stores
    if (typeof userStateData.embedded_total_monitoring_stores.store_ids !== "undefined" && userStateData.embedded_total_monitoring_stores.store_ids.length !== 0) {
      dashboardVars = {
        ...dashboardVars,
        Stores: userStateData.embedded_total_monitoring_stores.store_ids,
      }
    }

  }

  return dashboardVars;
}

const storeMonitoringDashboardVariables = () => {
  let dashboardVars = {};
  const userStateData = store.getState().userSelections;
  if (typeof userStateData.embedded_monitoring_store !== "undefined") {
    // stores
    if (typeof userStateData.embedded_monitoring_store.store_ids !== "undefined" && userStateData.embedded_monitoring_store.store_ids.length !== 0) {
      dashboardVars = {
        ...dashboardVars,
        Stores: userStateData.embedded_monitoring_store.store_ids,
      }
    }

  }

  return dashboardVars;
}

const receiptDashboardVariables = () => {
  let dashboardVars = {};
  const userStateData = store.getState().userSelections;
  if (typeof userStateData.embedded_receipt_monitoring_status !== "undefined") {
    // stores
    if (typeof userStateData.embedded_receipt_monitoring_status.store_ids !== "undefined" && userStateData.embedded_receipt_monitoring_status.store_ids.length !== 0) {
      dashboardVars = {
        ...dashboardVars,
        Stores: userStateData.embedded_receipt_monitoring_status.store_ids,
      }
    }

    // status
    if (typeof userStateData.embedded_receipt_monitoring_status.status !== "undefined" && userStateData.embedded_receipt_monitoring_status.status.length !== 0) {
      dashboardVars = {
        ...dashboardVars,
        Status: userStateData.embedded_receipt_monitoring_status.status,
      }
    }
  }

  if (typeof userStateData.embedded_receipt_monitoring_date !== "undefined") {
    // const endDate = new Date(userStateData?.embedded_receipt_monitoring_date.to);
    // endDate.setDate(endDate.getDate() + 1); // add one day to
    dashboardVars = {
      ...dashboardVars,
      Date: {
        from: userStateData?.embedded_receipt_monitoring_date.from,
        to: userStateData?.embedded_receipt_monitoring_date.to
      },
    }
  }

  return dashboardVars;
}

// campaign analytics tabs detail >> label, icon, dashboard and filter
export const tabs = () => {
  const checkUserDetails = checkUserDetailsFromCookie();
  let independentStoreList = independentStoreListOptions(); //multiple values
  let storeList = independentStoreListOptions(true); //single value
  let storeListMultiSelect = storeListOptionsForFilter("monitoring"); //for reciept monitoring
  const StoreIds = typeof storeList !== "undefined" ? findStoreIds(storeList) : [];

  if (
    checkUserDetails.success === true &&
    typeof checkUserDetails.user_detail !== "undefined" &&
    typeof checkUserDetails.user_detail.root_company_id !== "undefined"
  ) {
    const dirName = checkUserDetails.user_detail.root_company_id + "_master_" + process.env.REACT_APP_ENV_NAME;
    return [
      {
        label: "Status Monitoring",
        icon: <CheckBox />,
        unique_key: "status_monitor",
        dashboard:
          typeof independentStoreList !== "undefined" && independentStoreList.length !== 0 ? (
            dashboardMarkup(
              findEmbeddableId("infrastructure", "status_monitoring"),
              statusDashboardVariables()
            )
          ) : (
            <></>
          ),
        filter_component:
          typeof independentStoreList !== "undefined" && independentStoreList.length !== 0 ? (
            <StatusMonitoringFilter reduxKeywordToSaveValue={"embedded_store_monitoring_status"} />
          ) : (
            <></>
          ),
      },
      {
        label: "Total Monitoring",
        icon: <Visibility />,
        unique_key: "total_monitor",
        dashboard:
          typeof independentStoreList !== "undefined" && independentStoreList.length !== 0 ? (
            dashboardMarkup(
              findEmbeddableId("infrastructure", "total_monitoring"),
              totalMonitoringDashboardVariables(),
            )
          ) : (
            <></>
          ),
        filter_component:
          typeof independentStoreList !== "undefined" && independentStoreList.length !== 0 ? (
            <TotalMonitoringFilter />
          ) : (
            <></>
          ),
      },
      {
        label: "Store Monitoring",
        icon: <Store />,
        unique_key: "store_monitor",
        dashboard:
          StoreIds.length !== 0 ? (
            dashboardMarkup(
              findEmbeddableId("infrastructure", "store_monitoring"),
              storeMonitoringDashboardVariables(),
            )
          ) : (
            <></>
          ),
        filter_component: StoreIds.length !== 0 ? <StoreMonitoringFilter /> : <></>,
      },
      {
        label: "Receipt Monitoring",
        icon: <Receipt />,
        unique_key: "reciept_monitor",
        dashboard:
          typeof storeListMultiSelect !== "undefined" && storeListMultiSelect.length !== 0 ? (
            dashboardMarkup(
              findEmbeddableId("infrastructure", "receipt_monitoring"),
              receiptDashboardVariables()
            )
          ) : (
            <></>
          ),
        filter_component:
          typeof storeListMultiSelect !== "undefined" && storeListMultiSelect.length !== 0 ? (
            <RecieptMonitoringFilter storeArr={storeListMultiSelect} />
          ) : (
            <></>
          ),
      },
    ];
  } else {
    return [];
  }
};
